import { blogUseCaseUrlMappings } from '../constants/blogUseCase'
import { LocaleCodes, LocaleCodesSlugPrefix } from '../constants/localization.constants'
import { correctSlugPrefix } from './link.utils'

export const generateBlogPostSlug = ({
  slug, // ja/page-name
  blogCategoryName,
  pageLocale = LocaleCodes.ENGLISH.code,
  isCollectionListing = false,
}: {
  slug: string
  blogCategoryName: string
  pageLocale?: string
  isCollectionListing?: boolean
}) => {
  if (!slug && !blogCategoryName) return ''
  if (!blogCategoryName) return ''
  const isLocalized = !!slug.match(/^((de|es|ja|ko|pt|es|fr|tw)\/)/)
  let path: any = ''
  // if localized, remove the locale prefix
  if (pageLocale && pageLocale !== LocaleCodes.ENGLISH.code && isLocalized && slug) {
    path = slug.length > 2 && correctSlugPrefix(slug.slice(2))
  } else {
    path = correctSlugPrefix(slug)
  }
  let transformed = blogCategoryName
    .toLowerCase()
    .replace(/ *\([^)]*\) */g, '')
    .replace(/[^a-zA-Z0-9- ]/g, '')
    .replace(/\s/g, '-')
  if (transformed === 'artificial-intelligence' && !isCollectionListing) {
    transformed = 'ai'
  } else if (transformed === 'robotic-process-automation' && !isCollectionListing) {
    transformed = 'rpa'
  }

  if (
    pageLocale &&
    pageLocale !== LocaleCodes.ENGLISH.code &&
    pageLocale !== LocaleCodes.ENGLISH.name
  ) {
    path = `/${LocaleCodesSlugPrefix[pageLocale]}/blog/${transformed}${path}`
  } else {
    path = `/blog/${transformed}${path}`
  }
  return path
}

export const generateSecondaryBlogSlug = ({
  slug, // ja/page-name
  blogCategoryName,
  useCase,
  pageLocale,
}: {
  slug: string
  blogCategoryName: string
  useCase: string
  pageLocale?: string
}) => {
  // secondary requires useCase & blogCategoryName to be present
  if (!blogCategoryName || !useCase) return ''
  // transform blogCategoryName to slug format
  let catagoryTransformed = blogCategoryName
    .toLowerCase()
    .replace(/ *\([^)]*\) */g, '')
    .replace(/[^a-zA-Z0-9- ]/g, '')
    .replace(/\s/g, '-')

  // does slug have a locale prefix?
  const isLocalized = !!slug?.match(/^((de|es|ja|ko|pt|es|fr))/)
  let path: any = ''

  // if localized, remove the locale prefix
  if (pageLocale && pageLocale !== LocaleCodes.ENGLISH.code && isLocalized && slug) {
    path = slug.length > 2 && correctSlugPrefix(slug.slice(2))
  } else {
    path = correctSlugPrefix(slug)
  }

  // generate the slug for secondary blog pages
  if (useCase) {
    path = `/${blogUseCaseUrlMappings[useCase]}/${catagoryTransformed}${path}`

    if (
      pageLocale &&
      pageLocale !== LocaleCodes.ENGLISH.code &&
      pageLocale !== LocaleCodes.ENGLISH.name
    ) {
      path = `/${LocaleCodesSlugPrefix[pageLocale]}${path}`
    }
  }
  return path
}
